/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import {Table} from 'react-bootstrap';
import type {
	IStateConditionAction,
	Transformation,
	ConditionObject,
} from 'interfaces';

type TProps = {
	stateRowData: IStateConditionAction | undefined;
};

interface FlatConditionRow {
	nameGroup: string;
	tag: string;
	value: any;
	not?: boolean;
}

interface FlatActionRow {
	tag: string;
	value: any;
}

const WorkflowSummary = ({stateRowData}: TProps) => {
	const clearDataJson = (): IStateConditionAction | undefined => {
		if (!stateRowData) {
			return {
				conditions: [],
				actions: [],
				transformations: [],
			};
		}

		const tmpPolicyRow = JSON.parse(JSON.stringify(stateRowData));
		if (tmpPolicyRow) {
			const actionsArray = tmpPolicyRow?.actions || [];

			const tmpActions = [
				{
					...actionsArray,
				},
			];

			const transformationsArray = tmpPolicyRow?.transformations || [];

			const transformationObject: Transformation = {
				ReMap: transformationsArray.map((item: any) => {
					if (item._ && !item.ReMap) {
						return {_: item._, $: item.$};
					} else {
						return item;
					}
				}),
			};

			return {
				conditions: tmpPolicyRow.conditions,
				actions: tmpActions,
				transformations:
					transformationObject?.ReMap?.length > 0 ? [transformationObject] : [],
			};
		}
	};

	const isNumericKeyObject = (obj: any): boolean => {
		if (!obj || typeof obj !== 'object') return false;
		const keys = Object.keys(obj);
		return keys.every(k => /^\d+$/.test(k));
	};

	const flattenConditionFormForDisplay = (
		obj: Record<string, any>,
		orCountMap: Map<string, number>,
		parentKey = '',
		isArrayItem = false,
		inheritedGroupName?: string,
		indexInParent?: number,
	): FlatConditionRow[] => {
		if (!obj || typeof obj !== 'object') return [];

		let currentGroupName = inheritedGroupName ?? 'AND';

		if (obj.isGroup && obj.id) {
			if (!orCountMap.has(obj.id)) {
				orCountMap.set(obj.id, orCountMap.size + 1);
			}
			currentGroupName = `OR (${Number(orCountMap.get(obj.id))})`;
		}

		const result: FlatConditionRow[] = [];

		const isConditionObject = (val: any): val is ConditionObject<any> =>
			val && typeof val === 'object' && 'value' in val && 'active' in val;

		Object.entries(obj).forEach(([key, val]) => {
			if (key === 'isGroup' || key === 'id') return;
			let currentPath = parentKey ? `${parentKey}/${key}` : key;

			// Si tenemos índice, lo agregamos al tag (ejemplo: "tai/tac (1)")
			if (typeof indexInParent === 'number') {
				currentPath = `(${indexInParent + 1}) ${currentPath}`;
			}

			if (Array.isArray(val) || isNumericKeyObject(val)) {
				const arrayLike = Array.isArray(val) ? val : Object.values(val);
				arrayLike.forEach((item, idx) => {
					if (isConditionObject(item)) {
						if (item.active) {
							result.push({
								nameGroup: currentGroupName,
								tag: `(${idx + 1}) ${currentPath}`,
								value: item.value,
								...(item.notChecked !== undefined
									? {not: item.notChecked}
									: {}),
							});
						}
					} else if (typeof item === 'object') {
						result.push(
							...flattenConditionFormForDisplay(
								item,
								orCountMap,
								currentPath,
								true,
								currentGroupName,
								idx,
							),
						);
					}
				});
			} else if (isConditionObject(val)) {
				if (val.active) {
					result.push({
						nameGroup: currentGroupName,
						tag: currentPath,
						value: val.value,
						...(val.notChecked !== undefined ? {not: val.notChecked} : {}),
					});
				}
			} else if (val && typeof val === 'object') {
				result.push(
					...flattenConditionFormForDisplay(
						val,
						orCountMap,
						currentPath,
						false,
						currentGroupName,
					),
				);
			}
		});

		return result;
	};

	const groupFlatConditions = (
		flatRows: FlatConditionRow[],
	): FlatConditionRow[] => {
		const map = new Map<string, FlatConditionRow>();
		for (const row of flatRows) {
			if (map.has(row.tag)) {
				const existing = map.get(row.tag);
				if (existing) {
					const combinedValues = Array.isArray(existing.value)
						? [
								...existing.value,
								...(Array.isArray(row.value) ? row.value : [row.value]),
						  ]
						: [
								existing.value,
								...(Array.isArray(row.value) ? row.value : [row.value]),
						  ];

					map.set(row.tag, {
						nameGroup: row.nameGroup,
						tag: row.tag,
						value: combinedValues,
						not: row.not,
					});
				}
			} else {
				map.set(row.tag, {
					...row,
					value: Array.isArray(row.value) ? row.value : [row.value],
				});
			}
		}

		return Array.from(map.values());
	};

	const flattenActionsForDisplay = (
		obj: Record<string, any>,
		parentKey = '',
	): FlatActionRow[] => {
		if (!obj || typeof obj !== 'object') return [];

		const result: FlatActionRow[] = [];

		const isConditionObject = (val: any): val is ConditionObject<any> =>
			val && typeof val === 'object' && 'value' in val && 'active' in val;

		Object.entries(obj).forEach(([key, val]) => {
			const currentPath = parentKey ? `${parentKey}/${key}` : key;

			if (Array.isArray(val)) {
				val.forEach((item, index) => {
					if (isConditionObject(item) && item.active) {
						result.push({tag: `${currentPath}[${index}]`, value: item.value});
					} else if (typeof item === 'object') {
						result.push(...flattenActionsForDisplay(item, currentPath));
					}
				});
			} else if (isConditionObject(val)) {
				if (val.active) {
					result.push({tag: currentPath, value: val.value});
				}
			} else if (val && typeof val === 'object') {
				result.push(...flattenActionsForDisplay(val, currentPath));
			}
		});

		return result;
	};

	const groupFlatActions = (flatRows: FlatActionRow[]): FlatActionRow[] => {
		const map = new Map<string, FlatActionRow>();
		for (const row of flatRows) {
			if (map.has(row.tag)) {
				const existing = map.get(row.tag);
				if (existing) {
					const combined = Array.isArray(existing.value)
						? [...existing.value, row.value]
						: [existing.value, row.value];
					map.set(row.tag, {tag: row.tag, value: combined});
				}
			} else {
				map.set(row.tag, {
					tag: row.tag,
					value: Array.isArray(row.value) ? row.value : [row.value],
				});
			}
		}
		return Array.from(map.values());
	};

	return (
		<div className="row mb-4 bg-white rounded border pb-4 mx-0 pt-2">
			<div className="centered-div mb-2">
				<label htmlFor="filter-list-group" className="centered-label">
					Workflow Summary
				</label>
			</div>
			<div className="col-12 col-lg-6">
				<div className="table-responsive">
					<Table bordered className="text-center" id="tableConditionsSummary">
						<thead>
							{/* Full-width header */}
							<tr>
								<th colSpan={4} className="bg-gray-300">
									Conditions
								</th>
							</tr>
							{/* Secondary headers */}
							<tr id="workflow-summary">
								<th>GROUP</th>
								<th>(nº)TAG</th>
								<th>VALUE</th>
								<th>NEGATE</th>
							</tr>
						</thead>
						<tbody>
							{(() => {
								const orCountMap = new Map<string, number>();
								return (clearDataJson()?.conditions || [])
									.flatMap(conditionObj =>
										groupFlatConditions(
											flattenConditionFormForDisplay(conditionObj, orCountMap),
										),
									)
									.sort((a, b) => {
										if (a.nameGroup !== b.nameGroup) {
											return a.nameGroup.localeCompare(b.nameGroup);
										}

										return a.tag
											.toLowerCase()
											.localeCompare(b.tag.toLowerCase());
									})
									.reduce((acc: FlatConditionRow[][], row) => {
										const lastGroup =
											acc.length > 0 ? acc[acc.length - 1] : null;

										if (
											!lastGroup ||
											lastGroup[0].nameGroup !== row.nameGroup
										) {
											acc.push([row]);
										} else {
											lastGroup.push(row);
										}

										return acc;
									}, [])
									.map((groupRows, groupIdx) =>
										groupRows.map((row, rowIdx) => (
											<tr key={`${String(row.tag)}-${groupIdx}-${rowIdx}`}>
												{rowIdx === 0 && (
													<td rowSpan={groupRows.length}>{row.nameGroup}</td>
												)}
												<td>{row.tag}</td>
												<td className="td-wrap">
													{Array.isArray(row.value)
														? row.value.join(', ')
														: row.value}
												</td>
												<td>{row.not ? 'Yes' : 'No'}</td>
											</tr>
										)),
									);
							})()}
						</tbody>
					</Table>
				</div>
			</div>
			<div className="col-12 col-lg-6">
				<div className="table-responsive scrollable-table-workflow">
					<Table bordered className="text-center" id="tableActionSummary">
						<thead>
							{/* Full-width header */}
							<tr>
								<th colSpan={4} className="bg-gray-300">
									Actions
								</th>
							</tr>
							{/* Secondary headers */}
							<tr id="workflow-summary">
								<th>TAG</th>
								<th>VALUE</th>
							</tr>
						</thead>
						<tbody>
							{(() => {
								const actions = clearDataJson()?.actions?.[0] || {};
								return groupFlatActions(flattenActionsForDisplay(actions))
									.sort((a, b) => a.tag.localeCompare(b.tag))
									.map((row, idx) => (
										<tr key={`${row.tag}-${idx}`}>
											<td>{row.tag}</td>
											<td className="td-wrap">
												{Array.isArray(row.value)
													? row.value.join(', ')
													: row.value}
											</td>
										</tr>
									));
							})()}
						</tbody>
					</Table>
				</div>
			</div>
		</div>
	);
};

export default WorkflowSummary;
